// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"BW","fixed":"CW","nonLayerdFacets":"DW","productCount":"EW","facetBack":"FW","arrow":"GW"};